import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const getFonts = graphql(
  gql`
    mutation GetFonts {
      fontsData: getFonts {
        id
        family
        active
      }
    }
  `,
  { name: 'getFontsData' }
)

export const getPermissionsQuery = gql`
  query getPermissions {
    permissions: getPermissions {
      page
      edit
      view
    }
  }
`

export const getAlertsQuery = gql`
  query alerts {
    alerts: getValidAlerts {
      id
      sequence
      content
      backgroundColor: background_color
      onlyCheckout: only_checkout
    }
  }
`

export const getUserQuery = gql`
  query getUserProfile {
    profileData: getUserProfile {
      userProfile {
        userId: id
        managerName: account_manager_name
        triggerWelcome: trigger_welcome
      }
    }
  }
`

export const setMarketingSourceMutation = graphql(
  gql`
    mutation setMarketingSource($value: String) {
      setMarketingSource(value: $value) {
        short_id
      }
    }
  `,
  { name: 'setMarketingSource' }
)

export const requestColorChartMutation = gql`
  mutation RequestColorChart($userInfo: UserInfoInput) {
    requestColorChart(userInfo: $userInfo) {
      message
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MainLayout/data.ts